/** @format */
import Body from '@/widgets/body'
import { HomeTop } from '@/features/home'
import { HomeBottom } from '@/features/home'

const Home = () => {
  return (
    <div className='home-container bg-(--main-page-bg)'>
      <Body top={<HomeTop />} sectionClassName='gap-0' />
    </div>
  )
}

export default Home
